import { takeUntil } from 'rxjs/operators';
import { getTranslService } from './transl.service';

export function Transl() {
    return (target: Object, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;

        descriptor.value = function (...args) {
            const takeUntilFunc = this['componentDestroyed$'];
            getTranslService()
                .onTranslChange.pipe(takeUntilFunc ? takeUntil(takeUntilFunc) : noop)
                .subscribe(() => {
                    originalMethod.apply(this, args);
                });

            return originalMethod.apply(this, args);
        };

        return descriptor;
    };
}

const noop = (_: any) => _;
